import axios from 'axios'
import { host } from '../../helper/config'
import { getItemPerPage } from '../../helper/helper'

const PLUGINS_NAME = 'admin-print-queue'

export const getPrintQueueList = async (token, query, page) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/get-list`, {
        ...query,
        page: page,
        itemPerPage: getItemPerPage()
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return null
}

export const manualAssignPrintQueue = async (token, payload) => {
    // payload: { type: 'Vietlott'|'Classic'|'Loto', id: string, employeeId?: number|null }
    const response = await axios.post(`${host}/${PLUGINS_NAME}/manual-assign`, payload, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return { status: 'fail' }
}

export const cleanupCompletedPrintQueue = async (token) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/cleanup-completed`, {}, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return { status: 'fail' }
}
